"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CopyRight = void 0;
var react_1 = __importDefault(require("react"));
var CopyRight = function (_a) {
    var title = _a.title, titleUrl = _a.titleUrl;
    return (react_1.default.createElement("div", { className: "copyright-layout desc" },
        react_1.default.createElement("span", { className: "left-label m-l-8 " },
            "\u00A9 Copyright 2021 -",
            ' ',
            react_1.default.createElement("a", { href: titleUrl, target: "_black" },
                ' ',
                title)),
        react_1.default.createElement("span", { className: "m-r-8" }, "All Rights Reserved.")));
};
exports.CopyRight = CopyRight;
//# sourceMappingURL=CopyRight.js.map